import React from "react";
//
import { useGraphAPIHook } from "../../../portal";
import { recordUserDocumentVerification } from "@limitless/expert/apis/document-verification-api/UserDocumentVerification";
import { GET_PROFILE_FIELDS } from "../../apis/onboarding-queries/UserOnboardingVerificationQueries";
const DEFAULT_DOCUMENT_VERIFICATION_FIELDS = {
  loading: false,
  documentVerificationAttemptRemaining: null,
  transactionId: null,
  result: null,
  created: null,
  retries: null,
  error: null
};
export const useExpertOnboardingDocumentVerification = () => {
  const {
    fetchData
  } = useGraphAPIHook();
  const [userDocumentVerificationFields, setUserDocumentVerificationFields] = React.useState(DEFAULT_DOCUMENT_VERIFICATION_FIELDS);
  const updateUserDocumentVerificationFields = fields => {
    setUserDocumentVerificationFields({
      loading: false,
      transactionId: fields.documentVerification.transactionId,
      result: fields.documentVerification.result,
      created: fields.documentVerification.created,
      documentVerificationAttemptRemaining: fields === null || fields === void 0 ? void 0 : fields.documentVerificationAttemptRemaining
    });
  };
  const getDocumentVerificationProfileFields = () => {
    setUserDocumentVerificationFields({
      ...userDocumentVerificationFields,
      loading: true
    });
    const options = {
      dataKey: "getProfileFields",
      query: GET_PROFILE_FIELDS,
      functionName: "ExpertOnboardingDocumentVerificationHook getProfileFields"
    };
    fetchData(options).then(result => {
      updateUserDocumentVerificationFields(result);
    }).catch(() => {
      setUserDocumentVerificationFields({
        ...DEFAULT_DOCUMENT_VERIFICATION_FIELDS,
        loading: false
      });
    });
  };
  const sendDocumentVerificationTransactionId = transactionId => {
    setUserDocumentVerificationFields({
      ...userDocumentVerificationFields,
      loading: true
    });
    recordUserDocumentVerification(transactionId, response => {
      if (response.hasError) {
        setUserDocumentVerificationFields({
          ...DEFAULT_DOCUMENT_VERIFICATION_FIELDS,
          loading: false,
          error: true
        });
      } else {
        updateUserDocumentVerificationFields({
          ...response
        });
      }
    });
  };
  return {
    userDocumentVerificationFields,
    sendDocumentVerificationTransactionId,
    getDocumentVerificationProfileFields
  };
};